/** The text to show for a failure (§2.2): the API's `message` verbatim when there is one,
 * otherwise a generic sentence. Never shows stack traces or raw objects. */
export const GENERIC_ERROR = "Something went wrong. Please try again.";

export function errorMessage(error: unknown, fallback = GENERIC_ERROR): string {
  if (typeof error === "string") return error.trim() || fallback;
  if (error && typeof error === "object" && "message" in error) {
    const m = (error as { message?: unknown }).message;
    if (typeof m === "string" && m.trim()) return m;
  }
  return fallback;
}
